import { render } from "./PictureChoice.vue?vue&type=template&id=e60593ca&scoped=true"
import script from "./PictureChoice.vue?vue&type=script&lang=js"
export * from "./PictureChoice.vue?vue&type=script&lang=js"

import "./PictureChoice.vue?vue&type=style&index=0&id=e60593ca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e60593ca"

export default script